import { ListSortDirection, Sort } from "../../models/api/sort";
import { TravelExpenseTypeDTO } from "../../models/travel-expense-types/travel-expense-type-dto";
import { TravelExpenseTypeSTO } from "../../models/travel-expense-types/travel-expense-type-sto";
import { BaseApiService } from "../base";

export class TravelExpenseTypesApiService extends BaseApiService<TravelExpenseTypeDTO, TravelExpenseTypeSTO> {
  constructor() {
    super({
      servicePath: "/TravelExpenseTypes",
      loadItemsPath: "/GetTravelExpenseTypes",
      saveItemsPath: "/SaveTravelExpenseTypes",
    });

    this.defaultSort = [
      {
        name: "code",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
